import './i18n'
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@coreui/coreui/dist/css/coreui.min.css';

// Fix for Google Translate + React removeChild crash
const originalRemoveChild = HTMLElement.prototype.removeChild
HTMLElement.prototype.removeChild = function (child) {
  if (child.parentNode !== this) {
    return child
  }
  return originalRemoveChild.call(this, child)
}
const originalInsertBefore = HTMLElement.prototype.insertBefore
HTMLElement.prototype.insertBefore = function (newNode, referenceNode) {
  if (referenceNode && referenceNode.parentNode !== this) {
    return newNode
  }
  return originalInsertBefore.call(this, newNode, referenceNode)
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
